import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=30b65550&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=ts"
export * from "./OrderStatus.vue?vue&type=script&lang=ts"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=30b65550&prod&lang=scss"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=30b65550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b65550",
  null
  
)

export default component.exports